import SecuritySettingPage from "./SecuritySettingPage";

export default SecuritySettingPage;
